export default "__VITE_ASSET__96a6c1e4__"